import { useUrlOverlay, type UrlOverlay } from "@/lib/useUrlOverlay";
import {
  LOSS_RUNS_MARK,
  LOSS_RUNS_PARAM,
  readLossRunsPanel,
} from "@/lib/submissions/lossRunsPanel";

const LOSS_RUNS: UrlOverlay = {
  param: LOSS_RUNS_PARAM,
  read: (params) => (readLossRunsPanel(params) ? "1" : null),
  mark: LOSS_RUNS_MARK,
};

/** Whether the Loss runs panel is open, from the URL (BRK-S361), by any URL
 *  overlay's rules (`useUrlOverlay`). */
export function useLossRunsPanel() {
  const { value, open, close } = useUrlOverlay(LOSS_RUNS);
  return { open: value !== null, show: () => open("1"), close };
}
